import { useItem } from './hooks/use-context';

export function Dangers() {
  const { sections } = useItem();

  const questions = sections.flatMap((section) => section.questions);

  const probability = questions
    .find(
      (question) =>
        question.question_id === '4a503574-8b30-461f-8e7a-9f1fb001e269',
    )
    ?.answers?.[0]?.option?.split(' ')[0];

  const severity = questions
    .find(
      (question) =>
        question.question_id === 'c298a38a-836d-42a4-9f0d-bd094fe44cde',
    )
    ?.answers?.[0]?.option?.split(' ')[0];

  return (
    <div
      style={{
        border: '1px solid #ccc',
        borderRadius: '4px',
        backgroundColor: '#FFFFFF',
        marginBottom: '20px',
      }}
    >
      <h2
        style={{
          textAlign: 'center',
          fontSize: '14px',
          padding: '6px',
          backgroundColor: '#FAE0CD',
        }}
      >
        Perigos (Probabilidade x Severidade = Nível de Impacto)
      </h2>

      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          textAlign: 'center',
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                backgroundColor: '#FFFFFF',
              }}
            >
              Probabilidade
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                backgroundColor: '#FFFFFF',
              }}
            >
              Severidade
            </th>
            <th
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                backgroundColor: '#FFFFFF',
              }}
            >
              Nível de Impacto
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                backgroundColor: '#e6e6e6',
              }}
            >
              {parseFloat(probability?.replace(',', '.') || '0').toFixed(3)}
            </td>
            <td
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                backgroundColor: '#e6e6e6',
              }}
            >
              {parseFloat(severity?.replace(',', '.') || '0').toFixed(3)}
            </td>
            <td
              style={{
                border: '1px solid #ddd',
                padding: '8px',
                backgroundColor: '#e6e6e6',
              }}
            >
              {(parseFloat(probability?.replace(',', '.') || '0') *
                parseFloat(severity?.replace(',', '.') || '0')).toFixed(3)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
